import { render, staticRenderFns } from "./ChooseRegistryType.vue?vue&type=template&id=088bd074&"
import script from "./ChooseRegistryType.vue?vue&type=script&lang=js&"
export * from "./ChooseRegistryType.vue?vue&type=script&lang=js&"
import style0 from "./ChooseRegistryType.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports